module.exports = __webpack_public_path__ + "img/poll-people.b245b890.svg";